/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Backstagebrandingenabled2Inputs */

const en_entity_backstagebrandingenabled2 = /** @type {(inputs: Entity_Backstagebrandingenabled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backstage Branding Enabled`)
};

const de_entity_backstagebrandingenabled2 = /** @type {(inputs: Entity_Backstagebrandingenabled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backstage-Branding aktiviert`)
};

/**
* | output |
* | --- |
* | "Backstage Branding Enabled" |
*
* @param {Entity_Backstagebrandingenabled2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_backstagebrandingenabled2 = /** @type {((inputs?: Entity_Backstagebrandingenabled2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Backstagebrandingenabled2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_backstagebrandingenabled2(inputs)
	return de_entity_backstagebrandingenabled2(inputs)
});
export { entity_backstagebrandingenabled2 as "entity_backstageBrandingEnabled" }